import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as bootstrap from 'bootstrap';
import { EmpresaAPIService } from 'src/app/shared/services/empresa-api.service';
import { Fornecedor } from 'src/app/shared/interfaces/fornecedor/fornecedor.interface';

@Component({
  selector: 'app-modal-cadastro-fornecedor',
  templateUrl: './modal-cadastro-fornecedor.component.html',
  styleUrl: './modal-cadastro-fornecedor.component.scss'
})
export class ModalCadastroFornecedorComponent implements OnDestroy {
  @Output() fornecedorCriado = new EventEmitter<any>();

  fornecedor: Fornecedor = this.novoFornecedor();
  cepInvalido = false;
  isSaving = false;

  private destroy$ = new Subject<void>();

  constructor(
    private empresaService: EmpresaAPIService,
    private toastr: ToastrService,
    private http: HttpClient
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  abrirModal(): void {
    this.fornecedor = this.novoFornecedor();
    this.cepInvalido = false;
    this.isSaving = false;
    const el = document.getElementById('modal-cadastro-fornecedor');
    if (el) new bootstrap.Modal(el).show();
  }

  fecharModal(): void {
    const el = document.getElementById('modal-cadastro-fornecedor');
    if (el) {
      const modal = bootstrap.Modal.getInstance(el);
      if (modal) modal.hide();
    }
  }

  onSubmit(form: NgForm): void {
    if (!form.valid) {
      this.toastr.error('Preencha todos os campos obrigatórios.', 'Atenção');
      return;
    }

    const payload: Fornecedor = {
      ...this.fornecedor,
      nomeFantasia: this.fornecedor.nomeFantasia.toUpperCase(),
      cnpj:             this.fornecedor.cnpj?.replace(/\D/g, '') || '',
      telefone:         this.fornecedor.telefone?.replace(/\D/g, '') || '',
      telefoneCelular:  this.fornecedor.telefoneCelular?.replace(/\D/g, '') || '',
      cep:              this.fornecedor.cep?.replace(/\D/g, '') || ''
    };

    this.isSaving = true;
    this.empresaService.create(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.toastr.success('Fornecedor cadastrado com sucesso!', 'Sucesso');
          // O POST /empresas responde 201 sem corpo (res vazio). Emitimos o payload enviado,
          // que carrega cnpj/nomeFantasia, para o consumidor localizar o novo fornecedor na lista.
          this.fornecedorCriado.emit(res || payload);
          this.fecharModal();
          this.isSaving = false;
        },
        error: (err: any) => {
          const msg = err?.error?.message || 'Erro ao cadastrar fornecedor.';
          this.toastr.error(msg, 'Erro');
          this.isSaving = false;
        }
      });
  }

  buscarCep(): void {
    this.cepInvalido = false;
    const cepLimpo = this.fornecedor.cep?.replace(/\D/g, '') || '';
    if (cepLimpo.length !== 8) return;

    this.http.get<any>(`https://viacep.com.br/ws/${cepLimpo}/json/`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (dados) => {
          if (dados.erro) {
            this.cepInvalido = true;
            this.toastr.warning('CEP não encontrado!', 'Aviso');
          } else {
            this.fornecedor.logradouro  = dados.logradouro  || '';
            this.fornecedor.bairro      = dados.bairro      || '';
            this.fornecedor.cidade      = dados.localidade  || '';
            this.fornecedor.estado      = dados.uf          || '';
            if (dados.complemento) this.fornecedor.complemento = dados.complemento;
            this.fornecedor.cep = cepLimpo.replace(/(\d{5})(\d{3})/, '$1-$2');
            setTimeout(() => {
              const el = document.getElementById('mf-numero') as HTMLInputElement;
              if (el) el.focus();
            }, 100);
          }
        },
        error: () => {
          this.cepInvalido = true;
          this.toastr.error('Erro ao buscar CEP.', 'Erro');
        }
      });
  }

  private novoFornecedor(): Fornecedor {
    return {
      id: 0,
      nomeFantasia: '',
      razaoSocial: '',
      cnpj: '',
      inscricaoEstadual: '',
      inscricaoMunicipal: '',
      telefone: '',
      telefoneCelular: '',
      site: '',
      responsavel: '',
      tipoId: 2,
      ativo: true,
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: '',
      endereco: [],
      emails: []
    };
  }
}
